import { useMobileBreakpoint } from "@ob/theme";
import { createContext, useCallback } from "react";
import { useOnboardingApi } from "../api";
import { useFormMethods } from "../components/PageRenderer/useFormMethods";
import { errorLogger } from "../utils/error.utils";

type THeaderContext = {
  onBack?: () => void;
  backDisabled?: boolean;
  hideBack?: boolean;
};

export const useHeaderContext = () => {
  const { back, data, isLoading } = useOnboardingApi();
  const { methods } = useFormMethods(data?.step?.sections ?? []);
  const { isMobile } = useMobileBreakpoint();

  const handleBack = useCallback(() => {
    if (back) {
      back().catch(errorLogger);
      methods.reset(methods.getValues());
    }
  }, [methods, back]);

  return createContext<THeaderContext>({
    onBack: handleBack,
    backDisabled: data?.step.previous?.disabled || isLoading,
    hideBack:
      !isMobile ||
      !data?.step?.previous ||
      data?.step?.customComponent?.name === "onfido",
  });
};
